"use client";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { TrackersQuickBuyProvider } from "../-providers/trackers-quick-buy-provider";
import AddTrackedWalletModal from "./-components/AddTrackedWalletModal";
import SmartNotificationFormModal from "./-components/SmartNotificationFormModal";
import WalletsSmartNotifications from "./-components/WalletsSmartNotifications";
import WalletTrackerActionsBar from "./-components/WalletTrackerActionsBar";
import WalletTrackerContent from "./-components/WalletTrackerContent";
import WalletTrackerFiltersModal from "./-components/WalletTrackerFiltersModal";

export const Route = createFileRoute("/_main/trackers/wallets/")({
  head: () => ({
    meta: [{ title: "Reactor | Wallets" }],
  }),
  component: WalletsTrackerPage,
});

function WalletsTrackerPage() {
  const [showAddWalletModal, setShowAddWalletModal] = useState(false);
  const [isAddSmartNotificationModalOpen, setIsAddSmartNotificationModalOpen] =
    useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  return (
    <>
      <TrackersQuickBuyProvider>
        <div className="flex min-h-0 flex-1 flex-row justify-center gap-1.5">
          <div className="flex min-h-0 flex-1 flex-col gap-1.5">
            <WalletTrackerActionsBar
              onAddWallet={() => setShowAddWalletModal(true)}
              onAddSmartNotification={() =>
                setIsAddSmartNotificationModalOpen(true)
              }
              onFilterClick={() => setIsFilterModalOpen(true)}
            />
            <WalletTrackerContent
              onAddWallet={() => setShowAddWalletModal(true)}
              setIsAddSmartNotificationModalOpen={
                setIsAddSmartNotificationModalOpen
              }
            />
          </div>
          <WalletsSmartNotifications
            setIsAddSmartNotificationModalOpen={
              setIsAddSmartNotificationModalOpen
            }
          />
        </div>
      </TrackersQuickBuyProvider>

      <AddTrackedWalletModal
        open={showAddWalletModal}
        onOpenChange={setShowAddWalletModal}
      />
      <SmartNotificationFormModal
        open={isAddSmartNotificationModalOpen}
        onOpenChange={setIsAddSmartNotificationModalOpen}
      />
      <WalletTrackerFiltersModal
        open={isFilterModalOpen}
        onOpenChange={setIsFilterModalOpen}
      />
    </>
  );
}
